import { render } from "./TraderRatesBulkReportModal.vue?vue&type=template&id=d9ec1696&ts=true"
import script from "./TraderRatesBulkReportModal.vue?vue&type=script&lang=ts"
export * from "./TraderRatesBulkReportModal.vue?vue&type=script&lang=ts"

import "./TraderRatesBulkReportModal.vue?vue&type=style&index=0&id=d9ec1696&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__